import { render, staticRenderFns } from "./post.md?vue&type=template&id=052ecd3c&"
import script from "./post.md?vue&type=script&lang=js&"
export * from "./post.md?vue&type=script&lang=js&"
import style0 from "./post.md?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports